
    import './styles.scoped.css';
    export default {
  "with-motion-vertical": "awsui_with-motion-vertical_b18tp_w6i5v_146",
  "with-motion-horizontal": "awsui_with-motion-horizontal_b18tp_w6i5v_165",
  "resize-active": "awsui_resize-active_b18tp_w6i5v_184",
  "resize-side": "awsui_resize-side_b18tp_w6i5v_195",
  "resize-bottom": "awsui_resize-bottom_b18tp_w6i5v_198"
};
  